import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getLatestTdaVersion,
  TDA_VERSIONS,
} from "../types/pdf-generator.ts";

const years = [...new Set([getLatestTdaVersion(), ...TDA_VERSIONS])];

const BasicConfigSection = ({
  defaultLanguage,
  config,
  handleInputChange,
  updatePreset,
  disabled,
}) => {
  const { t } = useTranslation();

  // console.log("BasicConfigSection defaultLanguage", defaultLanguage);

  const [selectedPreset, setSelectedPreset] = useState(
    config.configPreset || ""
  );

  const handlePresetChange = (preset) => {
    setSelectedPreset(preset);
    updatePreset(preset);
  };

  if (!config.lang) {
    handleInputChange("lang", defaultLanguage);
  }

  return (
    <div className="param-group">
      <div className="param-group-header">
        <h3 className="param-group-title">
          <span>📋</span>
          {t("sections.basic.title")}
        </h3>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="form-group">
          <label className="form-label" htmlFor="version">
            {t("sections.basic.year")}
          </label>
          <select
            id="version"
            className="form-input"
            value={config.version || years[0]}
            onChange={(e) => handleInputChange("version", e.target.value)}
            disabled={disabled}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year} {year === years[0] && t("sections.basic.last")}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="lang">
            {t("sections.basic.language")}
          </label>
          <select
            id="lang"
            className="form-input"
            value={config.lang || defaultLanguage}
            onChange={(e) => handleInputChange("lang", e.target.value)}
            disabled={disabled}
          >
            <option value="en">🇺🇸 English</option>
            <option value="de">🇩🇪 Deutsch</option>
            <option value="es">🇪🇸 Español</option>
            <option value="fr">🇫🇷 Français</option>
            <option value="it">🇮🇹 Italiano</option>
            <option value="pt">🇵🇹 Português</option>
          </select>
        </div>
        <div className="col-span-2 form-group">
          <label className="form-label" htmlFor="preset">
            {t("sections.basic.preset")}
          </label>
          <select
            id="preset"
            className="form-input"
            value={selectedPreset}
            onChange={(e) => handlePresetChange(e.target.value)}
            disabled={disabled}
          >
            <option value="">✨ {t("sections.basic.preset.custom")}</option>
            <option value="basic">📄 {t("sections.basic.preset.basic")}</option>
            <option value="alinekarl">
              🎨 {t("sections.basic.preset.alinekarl")}
            </option>
            <option value="short">⚡ {t("sections.basic.preset.short")}</option>
          </select>
        </div>
        <div className="col-span-2 form-group">
          <label className="form-label" htmlFor="mainTitle">
            {t("sections.basic.documentTitle")}
          </label>
          <input
            type="text"
            id="mainTitle"
            className="form-input"
            value={config.mainTitle || "POKER TOURNAMENT DIRECTORS ASSN."}
            onChange={(e) => handleInputChange("mainTitle", e.target.value)}
            disabled={disabled}
            placeholder={t("sections.basic.documentTitlePlaceholder")}
          />
        </div>
      </div>
    </div>
  );
};

export default BasicConfigSection;
